import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route, useNavigate } from 'react-router-dom'
import RequestsLst from './RequestsLst'
import { useStores } from '../../../cls/stores/MobXProvider'
import { useSmartTranslation } from '../../../cls/TranslationContext'
// RequestsMain
/**
 * @component RequestsMain
 * @description Main router component for handling request-related views.
 * Ensures that only authorized users (admins or users with 'read' permission for requests) can access.
 * Redirects unauthenticated users to the logout page.
 *
 * @returns {JSX.Element} A set of routes for request handling or a permission error message.
 */
const RequestsMain = () => {
	const navigate = useNavigate()
	const { users } = useStores()
	const { loggedInUserId, loggedInUser } = users
	const isAdmin = loggedInUser?.isAdmin
	const isSuperAdmin = loggedInUser?.isSuperAdmin
	const { t } = useSmartTranslation()

	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}
	}, [loggedInUserId])

	// If the user does not have personal permission
	// and lacks the required permissions for the action and resource
	// Display a message indicating lack of permissions
	if (!(isAdmin || isSuperAdmin || users.canUser('read', 'requests'))) {
		return (
			<div style={{ textAlign: 'center' }}>
				{t('__denied.access').charAt(0).toUpperCase() +
					t('__denied.access%__feature-off%_request')
						.toLowerCase()
						.slice(1)}
			</div>
		)
	}

	return (
		<Routes>
			<Route index element={<RequestsLst />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(RequestsMain)
